export default __webpack_public_path__ + "static/media/chigenius-logo.d810bacf.png";